import { render, staticRenderFns } from "./DagreDirectedChart.vue?vue&type=template&id=47a3d756&scoped=true"
import script from "./DagreDirectedChart.vue?vue&type=script&lang=ts"
export * from "./DagreDirectedChart.vue?vue&type=script&lang=ts"
import style0 from "./DagreDirectedChart.vue?vue&type=style&index=0&id=47a3d756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3d756",
  null
  
)

export default component.exports